// import SchoolLevels from './screens/SchoolLevels';
import EnrollPage from './screens/EnrollPage';

const routes = [
  {
    path: "/enroll/:personaID",
    exact: true,
    name: "Matriculación",
    icon: "fa fa-university",
    component: EnrollPage,
    layout: "/admin",
    sidebar: false,
    roleID: 'ENROLL'
  }
 
] ;
  
  export default routes;